import React from "react";
import { Routes, Route } from "react-router-dom";
import { Site } from "./Site";
import Home from "./pages/Home";
import Program from "./pages/Program";
import Registration from "./pages/Registration";
import Committee from "./pages/Committee"
import SponsorRegistration from "./pages/SponsorRegistration";
import Contact from "./pages/Contact";
import AbstractSubmission from "./pages/AbstractSubmission";
import VisitingInformation from "./pages/VisitingInformation";




const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<Site />}>
        <Route index element={<Home />} />
        <Route path="committee" element={<Committee />} />
        <Route path="contact-us" element={<Contact />} />
        <Route path="program" element={<Program />} />
        <Route path="registration" element={<Registration />} />
        <Route path="sponsor-registration" element={<SponsorRegistration />} />
        <Route path="abstract-submission" element={<AbstractSubmission />} />
        <Route path="visiting-information" element={<VisitingInformation />} />
      </Route>
    </Routes>
  );
}

export default Routers;